/** Publish only profiles whose identity, biography and claims are approved.
 * Leave unverifiable optional fields absent. Never invent profile details.
 * Add up to three approved profiles here; no component changes are needed.
 * Until an approved photograph is available, use a clearly labeled neutral avatar.
 * Replace photoUrl with the approved photograph later; no component changes are needed.
 * Use a local public/ photo path or an HTTPS URL; video links must use HTTPS.
 */
export interface PitruAcharyaProfile {
  id: string;
  approved: boolean;
  name: string;
  photoUrl: string;
  biography: string;
  specializations: readonly string[];
  location: string;
  verifiedYearsOfExperience?: number;
  verifiedLanguages?: readonly string[];
  verifiedTraining?: string;
  videoIntroductionUrl?: string;
}

export const pitruAcharyas: readonly PitruAcharyaProfile[] = [

 {
  id: 'pandit-raj-malviya',
  approved: true,
  name: 'Acharya Raj Krishna Malviya Ji',
  photoUrl: '/images/pitru-acharyas/raj_malviya.jpg',
  location: 'Kashi, Varanasi',
  verifiedYearsOfExperience: 42,
  verifiedLanguages: ['Hindi'],
  specializations: [
    'Tripindi Shraddha',
    'Mahamrityunjay Jaap',
    'Rudrabhishek',
    'Chandi Path',
    'Ganesharchan',
    'Grih Pravesh',
    'Traditional Karmkand, Pujas & Jaap'
  ],
  biography:
    'Acharya Raj Krishna Malviya Ji is based in Kashi, Varanasi, and has 42 years of experience performing traditional Hindu Karmkand, pujas and spiritual anushthans. His regular work includes Tripindi Shraddha, Mahamrityunjay Jaap, Rudrabhishek, Chandi Path, Ganesharchan and Grih Pravesh. He communicates with families in Hindi.'
},
{
  id: 'sashidhar-pandey',
  approved: true,
  name: 'Acharya Shashidhar Pandey Ji',
  photoUrl: '/images/pitru-acharyas/shashidhar_pandey.jpg',
  location: 'Kashi, Varanasi',
  verifiedYearsOfExperience: 33,
  verifiedLanguages: ['Hindi'],
  specializations: [
    'Shraddha & Pind Daan',
    'Traditional Karmkand, Pujas & Jaap',
    'Yagya & Jap Anushthan',
    'Kundli Preparation',
    'Shri Ram Katha',
    'Shrimad Bhagwat Katha'
  ],
  biography:
    'Acharya Shashidhar Pandey Ji is a Kashi-based Vedic Acharya with 33 years of experience in traditional Hindu Karmkand, pujas and spiritual anushthans. His regular work includes Shraddha and Pind Daan, Yagya, Jap Anushthan, Kundli preparation, Shri Ram Katha and Shrimad Bhagwat Katha. He communicates with families in Hindi.'
}
];
